import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";

import {LOOK_OVERLAYS} from "../../../look/core/constants";
import {setLookAiImageOpened} from "../../aiActions";
import {getCommonVisualizerType, IS_QKB_UI} from "../../../../config";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {UserPopupContent, UserPopupTypes} from "../../../visComponents/constants";
import {setUserPopupContent} from "../../../../actions/userFunctions";
import UserLoginButton from "../../../ui/userLoginButton";
import {toggleUserPopup} from "../../../../actions/actionFunctions";
import {baseNewImagesPath} from "../../../assets";


const LookAIImageOverlayLoginContent = (props) => {

  const {setLookAiImageOpened, aiUserFileBlobUrl, setLookOverlayOpened, setUserPopupContent, aiResults, isMobile, toggleUserPopup} = props;

  const loginButtonClick = (action) => {
    setLookAiImageOpened(false);
    setUserPopupContent(action);
    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture, "aiLeadCapture");
    if (IS_QKB_UI) {
      UserLoginButton.handleLoginClick({
        toggleUserPopup,
        saveQuoteAfterLogin: true,
        userPopupType: UserPopupTypes.AIDesign
      })
    }
  }

  const visualizerType = getCommonVisualizerType();

  const activeResult = aiResults.find(aiResult => aiResult.isActive);

  return (
    <div className="flex--1 relative u-w-full u-h-full bg-center bg-cover bg-no-repeat u-rounded-025"
         style={{backgroundImage: `url(${activeResult ? activeResult.resultImageUrl : aiUserFileBlobUrl})`}}>
      {/* Sharp background layer */}
      {/* Blurred layer with masking */}
      <div className="absolute look-ai__overlay-blur u-w-full u-h-full bg-cover bg-center bg-no-repeat u-rounded-025"
           style={{backgroundImage: `url(${activeResult ? activeResult.resultImageUrl : aiUserFileBlobUrl})`}}/>
      <div className="absolute u-w-full u-h-full bg-no-repeat"
           style={{
             backgroundPosition: "left 1rem bottom 1rem",
             backgroundSize: "15%",
             backgroundImage: `url('${baseNewImagesPath + "images/Logos/Quote Kitchen and Bath - Powered By.svg"}')`
      }}/>
      {/* Content layer */}
      <div className="relative look-ai__overlay-login u-p-1 absolute flex flex--center u-left-0 u-w-full text-center">
        <div className="u-m-auto max-640 u-w-full">
          <h3 className={"u-mt-0 u-mb-1 bold" + (isMobile ? "" : " font--24")
            + (IS_QKB_UI ? " color-primary" : " color-active_text")}>
            {document.kvConfig.isBackend
              ? "You must save your design to continue."
              : <FormattedMessage id="look.ai.overlay.loginTitle" values={{visualizerType}}/>}
          </h3>
          <p className={"u-m-0 font--16 text-left" + (isMobile ? "" : " u-pr-4 u-pl-4")} style={{color: "#6B7B8D"}}>
            {document.kvConfig.isBackend
              ? "Create a new customer or select an existing customer from the menu."
              : <FormattedMessage id="look.ai.overlay.loginText" values={{visualizerType}}/>}
          </p>
          <div className={isMobile ? "u-mt-05 u-mb-05" : "u-mt-2 u-mb-2"}>
            <Button className={"look-button look-button--blue look-button--10-radius look-button--160 nowrap"
              + (IS_QKB_UI ? " u-pl-15 u-pr-15 ui-button2 ui-button2--green ui-button2--white2" : "")}
                    onClick={() => loginButtonClick(UserPopupContent.register)}>
              {document.kvConfig.isBackend
                ? "Continue"
                : <FormattedMessage id="look.ai.overlay.loginButton"/>}
            </Button>
          </div>
          {document.kvConfig.isBackend ? null : (
            <p className="u-m-0">
              <span style={{color: "#6B7B8D"}} className="u-pr-05">
                <FormattedMessage id="leadCapturePopup.loginText2"/>
              </span>
              <span className={"link cursor-pointer text-uppercase"
                + (IS_QKB_UI ? " hover:color-primary" : " hover:color-active_text")}
                    onClick={() => loginButtonClick(UserPopupContent.login)}>
                <FormattedMessage id="leadCapturePopup.loginButton"/>
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {aiUserFileBlobUrl, aiResults} = store.aiState;
  const {isMobile} = store.serverState;

  return {
    aiUserFileBlobUrl,
    aiResults,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookAiImageOpened,
  setLookOverlayOpened,
  setUserPopupContent,
  toggleUserPopup,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIImageOverlayLoginContent)
)
